import { showNotification } from "@mantine/notifications"

export const showErrorNotification = (title: string, message: string): void => {
  showNotification({
    title,
    message,
    autoClose: false,
    color: "red",
  })
}
